import { Navigate, Route, Routes } from "react-router-dom";

import { SubNav } from "@/app/Shell";
import { AssetCatalogActionPage } from "@/modules/asset_catalog/ActionPage";
import { ManufacturersPage } from "@/modules/asset_catalog/ManufacturersPage";
import { AssetCatalogOverviewPage } from "@/modules/asset_catalog/OverviewPage";

/** Asset Catalog (ASSET_CATALOG.md): Overview (all versions, filters, read
 *  drawer) · Product Models (add / edit, any kind) · Manufacturers.
 *
 *  THREE TABS BECAME ONE. Dattatray: *"we dont need 3 subpages under Asset
 *  Catalog ... We can have Batteries, Vehicle and Subcomponents in single
 *  tab: Name of that be Product Models ... Its easier for usability
 *  standpoint!"*
 *
 *  They were always ONE page. Batteries, Vehicles and Subcomponents rendered
 *  the same `AssetCatalogActionPage` with a narrower `kinds` prop — three
 *  routes for one component, differing only in which kinds the picker
 *  offered. A person had to know which tab a BMS lived under before they
 *  could add one, which is backwards: the form asks for the kind anyway.
 *
 *  IT ALSO REMOVES A BUG RATHER THAN ITS SYMPTOM. Sibling routes rendering
 *  one component type at one tree position reconcile instead of remounting,
 *  so switching tabs kept the previous tab's `pickKind` and `mode` — the
 *  D-84 defect, which distinct `key`s papered over. With one tab there are
 *  no siblings to confuse.
 *
 *  THE OLD PATHS REDIRECT rather than 404. They are in bookmarks and in the
 *  Overview drawer's deep links (`?id=`), and the SPA catch-all answers an
 *  unknown path with `index.html` — so a broken link would render a blank
 *  module instead of an error, which is the failure `tests/ui` exists for.
 */
export function AssetCatalogModule() {
  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <SubNav base="/asset-catalog" tabs={[
          { path: "overview", label: "Overview" },
          { path: "models", label: "Product Models" },
          { path: "manufacturers", label: "Manufacturers" },
        ]} />
      </div>
      <Routes>
        <Route path="overview" element={<AssetCatalogOverviewPage />} />
        {/* `kinds={[]}` = every kind, resolved from the templates the server
            sends. Not a hardcoded list here, so a product added in Products
            appears without this file knowing about it. */}
        <Route path="models" element={
          <AssetCatalogActionPage key="models" eyebrow="Asset Catalog"
            title="Product models" kinds={[]}
            desc="Add a model of any product, or edit one that exists. Choosing the product loads its own spec fields; lists and filters are on Overview." />} />
        <Route path="manufacturers" element={<ManufacturersPage />} />

        {/* Retired tabs. Bookmarks and the Overview drawer's deep links still
            point at them, and an unknown path renders a blank module rather
            than erroring, so these redirect and keep the query string. */}
        <Route path="batteries" element={<Navigate to="../models" replace />} />
        <Route path="vehicles" element={<Navigate to="../models" replace />} />
        <Route path="subcomponents" element={<Navigate to="../models" replace />} />

        <Route path="*" element={<Navigate to="overview" replace />} />
      </Routes>
    </>
  );
}
